import React, { useState } from 'react'
import SearchData from './searchData';
import { Link } from 'react-router-dom';
import { CLOSESEARCH_ICON, NODATAFOUND, SEARCHICON_IMG } from '../../../../utils/app-image-contant';


const GlobalSearch = ({ setIsSerach }) => {
    const searchData = SearchData();
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState(searchData);
    const handlleChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (value) {
            const filtered = searchData?.filter(item =>
                item?.name?.toLowerCase()?.includes(value?.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(searchData);
        }
    }

    return (
        <>
            <div className='search-btn d-flex visible pe-2'>
                <button
                    className="btn text-white button-bg p-0 px-2"
                    type="button"
                    onClick={() => setIsSerach(true)}
                >
                    <img
                        src={SEARCHICON_IMG}
                        alt="search"
                        className="img-fluid serchicon"
                    />
                </button>
                <input type='text' className='search-input' value={searchTerm} placeholder='Search here...' onChange={handlleChange} />
                <div className='d-flex justify-content-center align-items-center'>
                    <span><img src='' alt='' /><img src={CLOSESEARCH_ICON} alt='' className='search-cross' onClick={() => setIsSerach(false)} /></span>
                </div>
                {searchTerm && (
                    <div className='search_dataBox'>
                        <ul>
                            {filteredData?.map(item => (
                                <li key={item.id}>
                                    <Link to={item.url} className='serach-text mt-2'>{item.name}</Link>
                                </li>
                            ))}
                        </ul>
                        {
                            filteredData?.length == 0 && <div className='mb-0 d-flex justify-content-center align-items-center mt-5'><img src={NODATAFOUND} alt="" /></div>

                        }
                    </div>

                )}
            </div>



        </>
    )
}

export default GlobalSearch;
